/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions */
import clsx from 'clsx';

import React from 'react';

import { Attachment } from 'schema/Post/types';

import styles from './PhotoGrid.module.scss';

interface PhotoGridProps {
  images: Attachment[];
  onClick: (event: React.MouseEvent<HTMLDivElement>, index: number) => void;
  isReplyPanel?: boolean;
  isComment?: boolean;
}

// Returns grid-template-columns based on total images, similar to before.
const getGridTemplateColumns = (totalImages: number): string =>
  `repeat(${Math.min(totalImages, 4)}, 1fr)`;

const getWrapperHeight = (totalImages: number, isReplyPanel: boolean): string => {
  if (isReplyPanel) {
    return '110px';
  }
  if (totalImages === 1) return '400px';
  if (totalImages === 2) return '280px';
  if (totalImages === 3) return '204px';
  return '135px';
};

const getWrapperWidth = (isReplyPanel: boolean): string => {
  if (isReplyPanel) {
    return '110px';
  }
  return 'auto';
};

const PhotoGrid = ({
  images,
  onClick,
  isReplyPanel = false,
  isComment = false,
}: PhotoGridProps) => {
  const totalCount = images.length;
  // Display at most 4 images (like Facebook)
  const displayedImages = images.slice(0, 4);
  const extraCount = totalCount - 4;

  return (
    <div className={styles.post} data-qa="photo-grid">
      <div
        className={styles['image-gallery']}
        style={{ gridTemplateColumns: getGridTemplateColumns(totalCount) }}
      >
        {displayedImages.map((image, index) => (
          <div
            className={clsx(styles.imageWrapper, isReplyPanel && styles.replyPanelImageWrapper)}
            key={image.url}
            style={{
              height: getWrapperHeight(totalCount, isReplyPanel),
              width: getWrapperWidth(isReplyPanel),
            }}
          >
            <img
              alt={image.altText || ''}
              className={clsx(
                styles.image,
                totalCount === 1 && !isReplyPanel && !isComment ? styles.singleImage : ''
              )}
              src={image.url || ''}
              srcSet={`${image.url}?width=600 1x, ${image.url}?width=600&dpr=2 2x, ${image.url}?width=600&dpr=3 3x`}
              onClick={(event) => onClick(event, index)}
            />
            {extraCount > 0 && index === 3 && (
              /* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
              <div className={styles.overlay} onClick={(event) => onClick(event, index)}>
                +{extraCount}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PhotoGrid;
